import {Link} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Phone} from 'react-feather';
import FeaturesBottom from './FeaturesBottom';
function Help(){
    return (
        <>
            <Helmet>
                <title>Help Center - Kadhr</title>
                <meta name="description" content={`Help Center - Kadhr`} />
            </Helmet>
            <main className="mtopcon0 ovrflwhdn" id="up">
                <a href="https://wa.me/254794072134" target='_blank' rel="noreferrer" className="wappcomms btn-hover float-left">
                    <Phone className='text-white'/>
                </a>
                <div className="row">
                    <div className="col-12 text-center text-white pt-6indx">
                        <h1 className='mb-3 display-6 font-bold'><b><span className='text-primary'>Help</span> <span className='text-dark'>Center.</span></b></h1>
                    </div>  

                    <div className="col-12 pt-6indx0">
                        <div className='container containerwide'>
                            <div className="accordion" id="accordionExample">
                                
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq1" aria-expanded="true" aria-controls="faq1">
                                        How do I create an online store on Kadhr?
                                    </button>
                                    </h2>
                                    <div id="faq1" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        To create an online store, sign up for a Kadhr account, navigate to the dashboard, and follow the guided steps to set up your store profile, upload products, and customize your store’s appearance. You can also start selling instantly using Kadhr’s smart checkout links.
                                    </div>
                                    </div>
                                </div>
                                
                                
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2" aria-expanded="false" aria-controls="faq2">
                                        What payment methods does Kadhr support?
                                    </button>
                                    </h2>
                                    <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Kadhr supports multiple payment methods, including M-Pesa, credit/debit cards, bank transfers, and manual payment options. You can configure your preferred payment options in your store settings.
                                    </div>
                                    </div>
                                </div>
                                
                                
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq3" aria-expanded="false" aria-controls="faq3">
                                        How do I track my inventory?
                                    </button>
                                    </h2>
                                    <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Kadhr offers a built-in inventory management tool. Navigate to the "Products" tab in your dashboard to view stock levels, update quantities, and track product performance based on sales data.
                                    </div>
                                    </div>
                                </div>

                                
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq4" aria-expanded="false" aria-controls="faq4">
                                        Can I customize my store’s appearance?
                                    </button>
                                    </h2>
                                    <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Yes, Kadhr allows you to customize your store’s logo, colors, banners, and layouts. You can also create branded checkout links that match your business identity.
                                    </div>
                                    </div>
                                </div>

                                
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq5" aria-expanded="false" aria-controls="faq5">
                                        How does the loyalty program work?
                                    </button>
                                    </h2>
                                    <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Kadhr automatically identifies repeat customers and triggers personalized rewards, discounts, or reminders based on their purchase behavior. This helps bring customers back at the right time — without manual effort.
                                    </div>
                                    </div>
                                </div>
                                
                                
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq7" aria-expanded="false" aria-controls="faq7">
                                        Is Kadhr mobile-friendly?
                                    </button>
                                    </h2>
                                    <div id="faq7" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Yes, Kadhr is optimized for mobile use. You can manage your business, send messages, and track performance directly from your phone.
                                    </div>
                                    </div>
                                </div>
                                
                                
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq8" aria-expanded="false" aria-controls="faq8">
                                        What analytics does Kadhr provide?
                                    </button>
                                    </h2>
                                    <div id="faq8" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Kadhr provides insights into customer behavior, repeat purchase patterns, revenue trends, and product performance — helping you understand what drives your business growth.
                                    </div>
                                    </div>
                                </div>

                                
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq9" aria-expanded="false" aria-controls="faq9">
                                        How do I attract more customers to my store?
                                    </button>
                                    </h2>
                                    <div id="faq9" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Kadhr helps you grow by bringing back your existing customers through automated engagement, smart reminders, and personalized offers — turning one-time buyers into repeat customers.
                                    </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq10" aria-expanded="false" aria-controls="faq10">
                                        Is my data secure on Kadhr?
                                    </button>
                                    </h2>
                                    <div id="faq10" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Yes, Kadhr uses encryption, secure API authentication, and strict access controls to protect your data. Your business and customer information are handled securely at all times.
                                    </div>
                                    </div>
                                </div>

                                {/* NEW FAQ (added without breaking structure) */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq11" aria-expanded="false" aria-controls="faq11">
                                        Can I connect my existing store (e.g. WooCommerce)?
                                    </button>
                                    </h2>
                                    <div id="faq11" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Yes, Kadhr supports integrations such as WooCommerce. You can connect your store using your API key, allowing orders to sync automatically and enabling intelligent customer engagement.
                                    </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <FeaturesBottom/>


                </div>
            </main>
        </>
    )
}

export default Help;
